/** Low-cardinality / config-style lists and detail-panel sub-tables. */
export const TABLE_PAGE_SIZE_SM = 25;

/** Default for run / record / history tables that grow without bound. */
export const TABLE_PAGE_SIZE_MD = 50;

/** High-volume tables with light rows: events, charts, files, listings. */
export const TABLE_PAGE_SIZE_LG = 100;
